import { useEffect } from "react";

import styled from "styled-components/macro";

import background_amex from "Payments/CreditCardAssets/CardBackgrounds/amex_bg.jpg";
import border from "Payments/CreditCardAssets/CardBackgrounds/amex_border.png";
import background_discover from "Payments/CreditCardAssets/CardBackgrounds/discover_texture.jpg";
import face from "Payments/CreditCardAssets/LargeCardLogos/amex_man.png";
import logo_amex from "Payments/CreditCardAssets/LargeCardLogos/amex_words.png";
import logo_discover from "Payments/CreditCardAssets/LargeCardLogos/discover_logo.png";
import logoText from "Payments/CreditCardAssets/LargeCardLogos/mastercard_text.png";
import logo_visa from "Payments/CreditCardAssets/LargeCardLogos/visa_logo.png";
import logoWhite from "Payments/CreditCardAssets/LargeCardLogos/visa_white.png";
import { AnimatePresence } from "framer-motion";

import AmericanExpress from "./AmericanExpress";
import Discover from "./Discover";
import Mastercard from "./Mastercard";
import Visa from "./Visa";

export default function CardBackgrounds({
  cardType,
  isAlreadyExisting = false,
}) {
  const imagesToPreload = [
    logo_amex,
    border,
    background_amex,
    face,
    logo_discover,
    background_discover,
    logoText,
    logo_visa,
    logoWhite,
  ];

  useEffect(() => {
    imagesToPreload.forEach((picture) => {
      const img = new Image();
      img.src = picture;
    });
  }, []);

  return (
    <Wrapper>
      <AnimatePresence initial={!isAlreadyExisting}>
        {cardType === "Visa" && (
          <Visa key="visa" isAlreadyExisting={isAlreadyExisting} />
        )}
        {cardType === "Mastercard" && (
          <Mastercard key="mastercard" isAlreadyExisting={isAlreadyExisting} />
        )}
        {cardType === "American Express" && (
          <AmericanExpress key="amex" isAlreadyExisting={isAlreadyExisting} />
        )}
        {cardType === "Discover" && (
          <Discover key="discover" isAlreadyExisting={isAlreadyExisting} />
        )}
      </AnimatePresence>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  z-index: 2;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
